
export default {

    SortUpRedSvg: function() {

        return `<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"14\" height=\"14\" viewBox=\"0 0 18 18\">\n" +
                    "<defs>\n" +
                    "<clipPath id=\"clip-Sort_Up_Red\">\n" +
                    "<rect width=\"24\" height=\"24\"/>\n" +
                    "</clipPath>\n" +
                    "</defs>
                    "<g id=\"Sort_Up_Red\"clip-path=\"url(#clip-Sort_Up_Red)\">\n" +
                    "<rect width=\"16\" height=\"16\" fill=\"rgba(81,91,96,0)\"/>\n" +
                    "<g id=\"Group_13319\" data-name=\"Group 13319">\n" +
                    "<rect id=\"Rectangle_39\" data-name=\"Rectangle 39\" width=\"24\" height=\"24\" opacity=\"0\"/>\n" +
                    "<path id=\"Path_57\" class="svg-primary-color" data-name=\"Path 57\" d=\"M5,15l1.41,1.41L11,11.83V22h2V11.83l4.59,4.59L19,15,12,8Z\" transform=\"translate(0 -3)\" />\n" +
                    "</g>\n" +
                    "</g>\n" +
                    "</svg>`
    }
};



// WEBPACK FOOTER //
// ./src/common/plugins/svg/SortUpRedPlugin.js